
import Button from '../base/Button';

export default function Services() {
  const services = [
    {
      icon: 'ri-tooth-line',
      title: 'Reabilitação Oral',
      description: 'Restauração completa da função mastigatória e estética dental com técnicas avançadas.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Reabilitação Oral'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Implantes Dentários',
      description: 'Implantes de alta qualidade para substituição de dentes perdidos com resultados duradouros.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Implantes Dentários'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Cirurgias Ortognáticas',
      description: 'Correção de deformidades faciais e problemas de oclusão com cirurgia maxilofacial.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Cirurgias Ortognáticas'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Harmonização Orofacial',
      description: 'Procedimentos estéticos para equilibrar e harmonizar os traços faciais naturalmente.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Harmonização Orofacial'
    },
    {
      icon: 'ri-brush-line',
      title: 'Limpeza e Manutenção',
      description: 'Cuidados preventivos e manutenção da saúde bucal com acompanhamento especializado.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Limpeza e Manutenção'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Protocolos e Restaurações',
      description: 'Protocolos completos e restaurações personalizadas para cada necessidade específica.',
      link: 'https://wa.me/5544999297166?text=Olá Dr. Luiz, gostaria de saber mais sobre Protocolos e Restaurações'
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-4">
            Serviços do <strong className="text-[#6B2432]">Dr. Luiz Renato Kreb</strong>
          </h2>
          <p className="text-lg text-[#5A5A5A] max-w-3xl mx-auto">
            Tratamentos especializados em cirurgia buco-maxilo-facial e harmonização orofacial 
            com as mais modernas técnicas e tecnologias disponíveis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:border-2 hover:border-[#6B2432] group"
            >
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-[#6B2432]/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#6B2432] transition-colors duration-300">
                  <i className={`${service.icon} text-3xl text-[#6B2432] group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#5A5A5A] mb-3">
                  {service.title}
                </h3>
                <p className="text-[#5A5A5A] leading-relaxed mb-6">
                  {service.description}
                </p>
              </div>
              
              <div className="text-center">
                <Button
                  href={service.link}
                  variant="outline"
                  size="sm"
                  className="w-full"
                >
                  Falar com Dr. Luiz
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
